<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-full" :label="__('Name')" />
        </div>
        <div class="flex">
          <div class="p-8 -mr-6 -mb-8 flex">
            <text-input type="number" v-model="form.time_response" :error="form.errors.time_response" class="pr-6 pb-8 w-full" label="Tiempo de respuesta (horas)" />
          </div>
          <div class="p-8 -mr-6 -mb-8 flex">
            <text-input type="number" v-model="form.time_min_noti" :error="form.errors.time_min_noti" class="pr-6 pb-8 w-full" label="Tiempo para recordatorio (horas)" />
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }} {{ __('Priority') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Create Priority' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        time_response: null,
        time_min_noti: null,
        color: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('priorities.store'))
    },
  },
}
</script>
